module.exports = __webpack_public_path__ + "img/offre.c0c3a88f.png";